import {
    App, InputNumber, Form
} from 'antd';
import { useTranslation } from "react-i18next";
import { getLastOdo } from "../../api/vehicle";
import React, { useState, useEffect } from "react";
import {showApiError} from "../../utility/error/error-handler";

const OdoReadingField = ({vehicle, name, required, initialValue = null, width = '300px'}) => {

  const [lastOdo, setLastOdo] = useState(null);
  const { t } = useTranslation();
  const { notification } = App.useApp();

  useEffect(() => {
      if(vehicle)
      {
        getLastOdo(vehicle.vehicleId)
        .then(res => {
            setLastOdo(res);}, )
        .catch(err => {
          showApiError(t('title.submit_odo_reading'), err, notification);
        });
      }
    }, [t, notification, vehicle]);

    return (<Form.Item
          name={name || "newOdo"}
          help={lastOdo?.validationError}
          label={t('field.odo_reading')}
          initialValue={initialValue}
          type="number"
          rules={[
            { required: required, message: t('error.no_value_named', {0: t('field.odo_reading')})},
            () => ({
              validator(_, value) {
              if (!value && value !== 0 && required) {
                 return Promise.reject();
              }
              if ((value || value === 0) && isNaN(value)) {
                  return Promise.reject();
              }
              if ((value || value === 0) && (value < lastOdo?.reading)) {
                  return Promise.reject(t('error.minimum_value', {0: t('field.odo_reading'), 1: lastOdo?.reading}));
              }
              return Promise.resolve();
              },
            }),
           ]}
          >
           <InputNumber
               style={{width: width}}
               label={t('field.odo_reading')}
               changeOnBlur={true}
               type="number"
               controls={false}
               addonAfter={lastOdo?.unit}
               status={lastOdo?.validationError ? 'error' : ''}
               placeholder={t('action.enter_value')}
               pattern="[0-9]*"
               inputMode="numeric"
               max={9999999} />
        </Form.Item>);
}

export default OdoReadingField;